export default __webpack_public_path__ + "static/media/10_exit_interview.fa809885.jpg";